export default __webpack_public_path__ + "static/media/reset.84c4d0ef.svg";